import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch, FaStar, FaRegStar } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { UserContext } from '../context/UserContext';

export default function RatingStars({ value, onChange }) {
  const [hoverValue, setHoverValue] = useState(undefined);

  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((num) => {
        const filled = hoverValue ? num <= hoverValue : num <= value;

        return (
          <span
            key={num}
            className="cursor-pointer"
            onClick={() => onChange(num)}
            onMouseEnter={() => setHoverValue(num)}
            onMouseLeave={() => setHoverValue(undefined)}
          >
            {filled ? (
              <FaStar className="w-8 h-8 text-yellow-400" />
            ) : (
              <FaRegStar className="w-8 h-8 text-gray-300" />
            )}
          </span>
        );
      })}
    </div>
  );
}

export function ReviewModal({ apartment, setApartmentReview, setShowReviewModal, getData }) {
  const {userProfile, logOutFunction} = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const {setTostMessage} = useContext(TostMessageContext);
  const [cookies] = useCookies();

  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 min-h-[100px] w-[85%] lg:w-[35%] mx-auto my-auto bg-white rounded-[15px] animate-scaleIn'>
                <div onClick={() => setShowReviewModal(false)} className='w-[80%] flex justify-end text-underline text-[#ff0000] cursor-pointer'>Cancel</div>
                    <a className='text-dark text-[20px] font-bold'>Review of {apartment?.name}</a>
                    {/* Stars */}
                    {/* <div className="my-5">
                        <RatingStars value={rating} onChange={setRating} />
                    </div> */}

                    {/* Comment Box */}
                    <textarea
                    className="mt-10 w-[80%] mx-auto border border-gray-300 rounded-lg p-3 h-28 outline-none focus:border-blue-500"
                    placeholder={`Guest has not left any comments`}
                    value={apartment?.booking_comment}
                    readOnly
                    />
                {loading ? (
                    <ClockLoader
                        color={'#212121'}
                        loading={loading}
                        size={25}
                        className='mt-3'
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                    ) : null
                }
            </div>  
        </div>
    )
}

